<template>
  <v-card class="card-content">
    <v-list v-if="!withoutStudents" class="list-wrapper pb-0" two-line subheader>
      <StudentListHeader />
      <div class="list">
        <template v-for="(student, index) in students">
          <StudentListRowSelectable :student="student" :key="index" />
        </template>
      </div>
    </v-list>
    <v-layout justify-center row v-else class="mt-3">
      <p class="font-weight-regular text-xs-center">Não há estudantes registrados para este responsável!</p>
    </v-layout>
  </v-card>
</template>

<script>
import StudentListRowSelectable from './StudentListRowSelectable'
import StudentListHeader from './StudentListHeader'
import { mapState } from 'vuex'

export default {
  name: 'student-list',

  components: {
    StudentListRowSelectable,
    StudentListHeader
  },

  props: {
    students: {
      type: Array,
      default: null
    }
  },

  computed: {
    ...mapState({
      withoutStudents: state => state.responsibleInfos.withoutStudents
    })
  }
}
</script>

<style lang="stylus" scoped>
  .list-wrapper
    display flex
    flex-direction column
    flex 1
    overflow-x hidden
  .list
    overflow-y auto
    overflow-x hidden
    flex 1

  .card-content
    overflow hidden
</style>
